'use client';
import { useEffect } from 'react';
import { useMiniKit } from '@coinbase/onchainkit/minikit';

export function BaseRedirectGate() {
  const { context } = useMiniKit();
  
  useEffect(() => {
    // já está no baseapp.html? então não redireciona
    if (location.pathname.endsWith('/baseapp.html') || location.pathname === '/baseapp') return;
    
    // detecção oficial do Base App
    if (String(context?.client?.clientFid) === '309857') {
      console.log('🎯 Base App detected via MiniKit (clientFid: 309857)');
      location.replace('/baseapp.html?v=' + Date.now());
    }
  }, [context?.client?.clientFid]);
  
  return null;
}
